import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LanguageIcon from '@mui/icons-material/Language';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';

interface GuideProfileDetailsProps {
  guide: {
    languages: string[];
    destinations: string[];
    yearsOfExperience?: number;
  };
}

/** Public profile facts shown beneath the card (not part of the printable card). */
export function GuideProfileDetails({ guide }: GuideProfileDetailsProps) {
  return (
    <Box component="section" aria-labelledby="guide-profile-details-heading">
      <Typography id="guide-profile-details-heading" variant="h6" component="h2" fontWeight={800} sx={{ mb: 1.5 }}>
        About the Guide
      </Typography>
      <Stack spacing={1.25}>
        {guide.languages.length > 0 ? (
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
            <LanguageIcon fontSize="small" color="action" sx={{ mt: 0.25 }} />
            <Box>
              <Typography variant="caption" color="text.secondary" fontWeight={600}>
                Languages
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 0.5 }}>
                {guide.languages.map((lang) => (
                  <Chip key={lang} label={lang} size="small" />
                ))}
              </Box>
            </Box>
          </Box>
        ) : null}
        {guide.destinations.length > 0 ? (
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
            <PlaceOutlinedIcon fontSize="small" color="action" sx={{ mt: 0.25 }} />
            <Box>
              <Typography variant="caption" color="text.secondary" fontWeight={600}>
                Destinations
              </Typography>
              <Typography variant="body2">{guide.destinations.join(', ')}</Typography>
            </Box>
          </Box>
        ) : null}
        {typeof guide.yearsOfExperience === 'number' ? (
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <WorkHistoryOutlinedIcon fontSize="small" color="action" />
            <Typography variant="body2">
              {guide.yearsOfExperience} year{guide.yearsOfExperience === 1 ? '' : 's'} experience
            </Typography>
          </Box>
        ) : null}
      </Stack>
    </Box>
  );
}
